import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SearchPanel from "@widgets/SearchPanel";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_MTL_BAS_REG_008_POP_01 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    const gridRefs = useRef<any>(null);
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns1, setColums1] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);

    const getSelectedRowData = () => {
      const rowData = gridRefs.current?.getSelectedRow();
      return rowData ? rowData : [];
    };

    useImperativeHandle(ref, () => ({
      checkValidity: () => ({ flag: true }),
      getSelectedRow: getSelectedRowData,
      getOkayData: () => ({
        rtnData: getSelectedRowData(),
      }),
    }));

    useEffect( () => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_MTL_BAS_REG_008_POP_01",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums1(rtn.grid.grid1);
        } catch (error) {}
      };
      fetchform().then()
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_mtl_bas_reg_008_pop_01",
          params: searchRef.current.getFormdata(),
        };

        setDataSource1([]);
        const data: any = await fnGetDataSet(param);
        setDataSource1(data[0]);
      } catch (error: any) {}
    };

    const onRowDoubleClick = async (event: any) => {
      modalRef.current?.handleConfirm(true, event.node?.data[0]);
    };

    return (
      <div className={"overflow-y-hidden"}>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{
              width: 80,
              marginTop: 1.5,
            }}
            spinner={true}
          />
        </div>
        <div>
          <div style={{ height: "60vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridRefs}
              columnConfig={columns1}
              rowData={dataSource1}
              rowSelection="single"
              isEditable={false}
              enableAddRow={false}
              onRowDoubleClicked={onRowDoubleClick}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_MTL_BAS_REG_008_POP_01;
